module.exports = __webpack_public_path__ + "img/lxwm.0ade7c4f.png";